import { render, staticRenderFns } from "./MateriaCodigoClaseVideo.vue?vue&type=template&id=3fba78c9"
import script from "./MateriaCodigoClaseVideo.vue?vue&type=script&lang=js"
export * from "./MateriaCodigoClaseVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports